import React from 'react';
import { connect } from 'react-redux';

class FormDropdown extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        jQuery("body").on("mouseleave", "#dropdownMenuButton", function () {
            jQuery(this).tooltip('hide').attr('data-original-title', $(this).attr('data-title'));
        });

        jQuery("body").on("mouseenter", "#dropdownMenuButton", function () {
            jQuery(this).tooltip('hide').attr('data-original-title', $(this).attr('data-title'))
            jQuery(this).tooltip('show');
        });
    }


    render() {
        return (
            <div className={this.props.classes ?? ""}>
                <div className="dropdown timeline-dropdown-feedbacks">
                    <input
                        type="hidden"
                        className="timelineFeedbackHiddenInput"
                        value={this.props.title ?? ""}
                    />
                    <button
                        data-second-toggle="tooltip"
                        data-placement="top"
                        data-title={this.props.tooltip ?? ''}
                        className={"dropdown-toggle second-input input-primary w-100 d-flex form-dropdown d-flex align-items-center " + this.props.buttonClasses ?? ""} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-offset={this.props.offset ?? null}>
                        {this.props.title}
                        {this.props.titleCount != null ? <span className="dropdown-title-count d-xl-none ml-1">({this.props.titleCount})</span> : null}
                    </button>
                    <div className={"dropdown-menu dropdown-menu-right " + this.props.menuClasses ?? ""} aria-labelledby="dropdownMenuButton">
                        {this.props.items.filter(item => (item && item.text)).map((item, index) => {
                            return <a style={{ userSelect: "none" }} className="dropdown-item d-flex align-items-center cursor-pointer" onClick={this.props.itemOnClickFunction ?? null} id={item.id ?? null} href={item.link ?? null} key={index}>{item.text ?? null}{item.range ? <span className="timeframe-option-range ml-auto pl-3">{item.range}</span> : null}{item.count != null ? <span className="dropdown-option-count ml-auto pl-3 d-xl-none">({item.count})</span> : null}</a>
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FormDropdown);
